import { request as RequestService, requestV2 } from "#/utils/request";
import {
  Banner,
  PayloadRedeemPoints,
  PayloadRedirectDecolar,
  RedeemPoints,
  MilesPropertiesData,
  LiveloProgramData,
} from "./types";

const PartnersShowcaseService = {
  getBanners: async () => {
    return (await RequestService.get<Banner[]>(`/banners`)).data;
  },
  getMilesProperties: async () => {
    return (await requestV2.get<MilesPropertiesData[]>("/v1/miles-properties"))
      .data;
  },

  getRedeemPoints: async (cpf: string, cnpj?: string) => {
    if (!cnpj && !cpf) {
      throw new Error("CPF ou CNPJ é obrigatorio");
    }

    return (
      await requestV2.get<RedeemPoints>(`/v1/partner-loyalty/clients/points`)
    ).data;
  },
  postRedeemPoints: async (payload: PayloadRedeemPoints | null) => {
    return await RequestService.post<PayloadRedeemPoints>(
      `/v1/partner-loyalty-miles/redemption`,
      payload
    );
  },
  postLiveloProgram: async () => {
    return (await requestV2.post<LiveloProgramData>(`/v1/program-livelo`)).data;
  },
  postRedirectDecolar: async (payload: PayloadRedirectDecolar | null) => {
    return await RequestService.post<PayloadRedirectDecolar>(
      `/v1/partner-loyalty-miles/request/redirect`,
      payload
    );
  },
};

export default PartnersShowcaseService;
